// extracted by mini-css-extract-plugin
export default {"password":"password_password__H3vU6","btn":"password_btn__gNyZj"};